module.exports = "/pages/business/hotelslabo/first_view_background_pc.jpg";